import React, { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { fmtDate } from "@/lib/dateUtils";

/* Date picker that always displays dd/mm/yyyy. Value in/out is ISO yyyy-mm-dd. */
export function DateField({ value, onChange, testid, className = "", placeholder = "dd/mm/yyyy" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T12:00:00`) : undefined;
  const pick = (d) => {
    if (!d) { onChange(""); setOpen(false); return; }
    const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, "0"), dd = String(d.getDate()).padStart(2, "0");
    onChange(`${y}-${m}-${dd}`);
    setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`inline-flex items-center gap-2 text-left ${className || "text-sm border border-neutral-300 rounded-md px-3 py-2"}`}>
          <CalendarIcon size={13} className="opacity-50 shrink-0" />
          {value ? <span>{fmtDate(value)}</span> : <span className="text-neutral-400">{placeholder}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[80] bg-white" align="start">
        <Calendar mode="single" selected={selected} onSelect={pick} defaultMonth={selected} />
      </PopoverContent>
    </Popover>
  );
}
